export default "__VITE_ASSET__b0f04cfb__"